import React, { useEffect, useState } from "react";
import "./GroupView.css";
import supabase from "../../../supabaseClient";

const MediaTab = ({ groupId }) => {
  const [mediaPosts, setMediaPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchMediaPosts = async () => {
      setLoading(true);
      // Fetch posts for the group with media
      const { data: posts, error } = await supabase
        .from("posts")
        .select("id, user_id, media_url, media_type, created_at")
        .eq("group_id", groupId)
        .not("media_url", "is", null);
      if (error) {
        setMediaPosts([]);
        setLoading(false);
        return;
      }
      // Generate public URLs for media
      const postsWithPublicUrls = await Promise.all(
        posts
          .filter(
            post => post.media_url && (post.media_type?.startsWith("image") || post.media_type?.startsWith("video"))
          )
          .map(async post => {
            let publicUrl = post.media_url;
            // If media_url is a path (not a full URL), get public URL from Supabase storage
            if (post.media_url && !/^https?:\/\//.test(post.media_url)) {
              const { data } = supabase.storage.from("post-media").getPublicUrl(post.media_url);
              if (data?.publicUrl) {
                publicUrl = data.publicUrl;
              }
            }
            return { ...post, media_url: publicUrl };
          })
      );
      setMediaPosts(postsWithPublicUrls);
      setLoading(false);
    };
    if (groupId) fetchMediaPosts();
  }, [groupId]);

  return (
    <div className="media-tab">
      <h2>Group Media</h2>
      <div className="media-grid">
        {loading ? (
          <div>Loading media...</div>
        ) : mediaPosts.length > 0 ? (
          mediaPosts.map(post => (
            <div className="media-card" key={post.id}>
              {post.media_type.startsWith("image") ? (
                <img src={post.media_url} alt="media" className="media-img" />
              ) : post.media_type.startsWith("video") ? (
                <video src={post.media_url} controls className="media-video" />
              ) : null}
              <div className="media-meta">
                <span className="media-author">{post.user_id}</span>
                <span className="media-date">{new Date(post.created_at).toLocaleString()}</span>
              </div>
            </div>
          ))
        ) : (
          <div>No media found in this group.</div>
        )}
      </div>
    </div>
  );
};

export default MediaTab;